import { BaseController } from '../../base/controller';

class StockListController extends BaseController {
  toTransfer = [];
  currency = 'EUR';

  constructor(controllerService, $scope, $rootScope) {
    'ngInject';
    super({ controllerService, $scope, $rootScope });
  }

  $onInit() {
    for (let item of this.list) {
      if (this.toTransfer.length !== this.list.length) {
        this.toTransfer.push({ ...item });
      }
    }
  }

  get total() {
    let total = 0.0;
    for (let item of this.list) {
      total += this.getSum(item);
    }
    return total;
  }

  get sum() {
    let sum = 0;
    for (let i = this.toTransfer.length - 1; i >= 0; i--) {
      sum += this.getSum(this.toTransfer[i]);
    }
    return sum;
  }

  get rest() {
    return this.total.toFixed(3) - this.sum.toFixed(3);
  }

  getSum(item, price = item.price) {
    price = parseFloat(price) || 0;
    return item.quantity * price;
  }

  getRest(total, item) {
    return (total.quantity - item.quantity) * total.price;
  }

  removeStockEntry(index) {
    this.list.splice(index, 1);
    this.toTransfer.splice(index, 1);
    this.$rootScope.$broadcast('stockListChanged', {
      list: this.list,
      toTransfer: this.toTransfer,
    });
  }
}

export default StockListController;



// WEBPACK FOOTER //
// ./src/app/common/ui/stockList/stockList.controller.js